import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/noData.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4b8e1f95"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "nothing flex flex-column align-center"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createTextVNode(" " + _toDisplayString(_ctx.text), 1)]);
}